var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#060B1B","min-width":"1920px"}},[_c('div',{staticStyle:{"width":"1920px","height":"1080px","margin":"0 auto","overflow":"hidden"}},[_c('bigData',{attrs:{"tips":_vm.tips}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }